export default "__VITE_ASSET__d55403b2__"